export default "/assets/images/bbq-video-thumbnail.07c934d4dff66a15.jpg";